import { render, staticRenderFns } from "./TeamHealthCard.vue?vue&type=template&id=2639d9fa&scoped=true&"
import script from "./TeamHealthCard.vue?vue&type=script&lang=js&"
export * from "./TeamHealthCard.vue?vue&type=script&lang=js&"
import style0 from "./TeamHealthCard.vue?vue&type=style&index=0&id=2639d9fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2639d9fa",
  null
  
)

export default component.exports